import { GetFieldDefFromName } from "@/Utils/DataLib";
import { appstr } from "@coreapp/utils/appstr";
import {
  enumSubChartOption,
  kSmartBreakOptions,
  kStartLevelOptions,
  kLevelOptions,
  enumSCDensity,
  enumFeaturesList
} from "@coreapp/constants";
import { MapDensityToStr } from "@coreapp/utils/MapDensityToStr";
import { getFeatureAccess } from "@/Utils/Misc";

export const ScOptions = (showAsIs = false) => [
  ...(showAsIs ? [["Keep pagination as-is", enumSubChartOption.keepAsIs]] : []),
  ["nobreaks", enumSubChartOption.nobreak],
  ...(getFeatureAccess(enumFeaturesList.autoSubchartBreaks)
    ? [["autobreaks", enumSubChartOption.autobreaks]]
    : []),
  ["breakbylevel", enumSubChartOption.breakbylevel],
  ["breakbyfield", enumSubChartOption.breakbyfield]
];

export const NormalizeSCWiz = scWiz => {
  return {
    scChartBreakType: scWiz.GetSubChartOption(),
    startbreaksat: scWiz.GetSmartStartLevel()?.match(/\d/g)?.join(""),
    nameusing: scWiz.GetSubChartNameFieldID() || GetDefaultNameUsing(scWiz),
    pagedensity: scWiz.GetPageDensity(),
    breakevery: scWiz.GetBreakLevels()?.match(/\d/g)?.join(""),
    breakfield: scWiz.GetBreakField(),
    minsubsforbreak: scWiz.GetSmartBreak()?.match(/\d/g)?.join("")
  };
};

export const GetDefaultNameUsing = scWiz => {
  var fieldID = null;
  var deptID = appstr("Department");
  var nameID = appstr("Name");
  var fieldName = GetFieldDefFromName(deptID);
  if (fieldName == null) {
    fieldName = GetFieldDefFromName(nameID);
    if (fieldName != null) fieldID = nameID;
  } else fieldID = deptID;

  if (fieldID != null) scWiz.SetSubChartNameFieldID(fieldID);

  return fieldID;
};

export const BuildDensityOptions = clickHandler => {
  let options = [];
  for (let densityKey in enumSCDensity) {
    let theDensity = enumSCDensity[densityKey];
    let option = {};
    option.label = MapDensityToStr(theDensity);
    option.name = "density";
    option.value = theDensity;
    option.clickHandler = () => clickHandler("pagedensity", option.value);
    options.push(option);
  }
  return options;
};

export const BuildBreaksAtOptions = clickHandler => {
  let options = [];
  for (let levelVal of kStartLevelOptions) {
    let option = {};
    option.label = appstr("Level") + " " + levelVal;
    option.name = "level";
    option.dataTestId = `pagination-start-breaks-at--${levelVal}`;
    option.value = levelVal;
    option.clickHandler = () => clickHandler("startbreaksat", option.value);
    options.push(option);
  }
  return options;
};

export const BuildBreaksEveryOptions = clickHandler => {
  let options = [];
  for (let levelVal of kLevelOptions) {
    let option = {};
    option.label = levelVal + " " + appstr("Levels");
    option.name = "level";
    option.value = levelVal;
    option.dataTestId = `pagination-break-every--${levelVal}`;
    option.clickHandler = () => clickHandler("breakevery", option.value);
    options.push(option);
  }
  return options;
};

export const BuildNameUsingOptions = (fields, clickHandler) => {
  let options = [];
  for (let field of fields) {
    let option = {};
    option.label = field;
    option.name = "boxes";
    option.value = field;
    option.clickHandler = () => clickHandler("nameusing", option.value);
    options.push(option);
  }
  return options;
};

export const BuildMinSubBreakOptions = clickHandler => {
  let options = [];
  for (let minVal of kSmartBreakOptions) {
    let option = {};
    option.label = minVal + " " + appstr("Boxes");
    option.name = "boxes";
    option.value = minVal;
    option.clickHandler = () => clickHandler("minsubsforbreak", option.value);
    options.push(option);
  }
  return options;
};

export const BuildBreakFieldOptions = (fields, clickHandler) => {
  let options = [];
  for (let field of fields) {
    if (field === "Level") continue;
    let option = {};
    option.label = field;
    option.name = "boxes";
    option.value = field;
    option.dataTestId = `pagination-break-field--${field}`;
    option.clickHandler = () => clickHandler("breakfield", option.value);
    options.push(option);
  }
  return options;
};
